import ModalBlocked from "./modal-blocked";
import ModalNonBlocked from "./modal-non-blocked";
import Toast from "./toast";
import { onDomReady } from "../../services/on-dom-ready";
import Modal from "./modal";

window.ModalBlocked = ModalBlocked;
window.ModalNonBlocked = ModalNonBlocked;
window.Toast = Toast;

const initModals = () => {
  onDomReady
    .then(() => {
      document.body.addEventListener("remove.modal", () => {
        Modal.closeAll();
      });

      document.addEventListener("click", e => {
        let toggler = e.target.closest('[data-modal-toggler]');

        if (toggler) {
          let modalSelector = toggler.dataset.modalToggler;
          let modals = document.querySelectorAll(modalSelector);

          toggler.classList.add('dropdown-shown');

          modals.forEach(modalBlock => {
            let modal = ModalNonBlocked.get(modalBlock);
            let name = modalBlock.dataset.modal;
            modal.open();
            if (name) document.body.classList.add(`modal-${name}`);
            modalBlock.addEventListener(Modal.events.closed, () => {
              toggler.classList.remove('dropdown-shown');
              if (name) document.body.classList.remove(`modal-${name}`);
            }, { once: true });
          });
        }

        const subMenuItem = e.target.closest("[data-sub-menu]");

        document.querySelectorAll(".sub-opened")
        .forEach(subMenu => subMenu.classList.remove("sub-opened"));

        if (subMenuItem) {
          subMenuItem.classList.add("sub-opened");
        }
      });
    })
    .catch(err => {
      console.error(err);
    });
};



export { initModals };